module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 1_Non-pro.bfd02ef3.svg";